// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"xg3e3","modalControls":"_4WIMl","deleteBtnWrapper":"_1Qlup"};